<template>
  <div class="out_wrap">
    <div class="set">
      <el-form ref="ruleForm" :model="setForm" label-width="100px" class="mb35">
        <el-form-item label="ComKey：">
          <el-input id="appid" v-model="setForm.appid" type="text" placeholder="AppID" readonly>
            <a slot="suffix" class="active_color mr15" @click="copy">复制</a>
          </el-input>
        </el-form-item>
        <el-form-item label="ComSecret：">
          <a class="active_color" @click="look">查看</a>
        </el-form-item>
        <el-form-item label="回调地址：">
          <el-input v-model="setForm.callback_url" type="text" placeholder="回调地址" :readonly="!isEdit" />
        </el-form-item>
        <el-form-item label="IP：" required>
          <div v-for="(item, index) in setForm.ips" :key="index" class="flex_between pr" :class="{mb22: index != setForm.ips.length - 1}">
            <el-input v-model.trim="item.ip" type="text" placeholder="IP" class="w100" :readonly="!isEdit" />
            <a v-if="isEdit" class="del delip pa" @click="delIP(index,item.ip)">删除</a>
            <a v-if="isEdit" class="add saveip pa" @click="save('ruleForm',index, item.ip)">保存</a>
          </div>
          <a v-if="isEdit" class="active_color block" style="margin-top: 22px;" @click="addIP">添加IP</a>
        </el-form-item>
        <el-form-item label="接口文档：">
          <a class="active_color" :href="docUrl" target="_blank">查看</a>
        </el-form-item>
      </el-form>
      <div class="center">
        <el-button v-if="isEdit" type="primary" @click="save('ruleForm', -1, '')">保存</el-button>
        <el-button v-if="isEdit" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getConfig, setConfig } from '@/api/set'
export default {
  data() {
    // const checkBackUrl = (rule, value, callback) => {
    //   if (!this.isEdit) {
    //     callback()
    //   } else {
    //     if (!value) {
    //       callback(new Error('请输入回调地址'))
    //     } else {
    //       callback()
    //     }
    //   }
    // }
    return {
      setForm: {},
      // rules: {
      //   callback_url: [{ required: true, validator: checkBackUrl, trigger: 'change' }]
      // },
      isEdit: true,
      storeData: null,
      docUrl: 'https://apifox.com/apidoc/shared-2cf8cb5a-46b6-450a-8b6f-0381d49c7dd0?pwd=sYqIUqme'
    }
  },
  created() {
    this.queryInfo()
  },
  methods: {
    queryInfo() {
      getConfig().then(res => {
        const parse = res.data
        if (res.code === 200) {
          parse.ips = []
          if (parse.ip) {
            for (const i of parse.ip.split(',')) {
              parse.ips.push({ ip: i })
            }
          } else {
            parse.ips = [{ ip: '' }]
          }
          this.setForm = parse
        }
      })
    },
    edit() {
      this.storeData = JSON.parse(JSON.stringify(this.setForm))
      this.isEdit = !this.isEdit
    },
    save(formName, index, ip) {
      setConfig({
        callback_url: this.setForm.callback_url,
        ip: [...this.setForm.ips.map(d => d.ip)].filter(d => d).toString()
      }).then(res => {
        if (res.code === 200) {
          this.$message({ type: 'success', message: '设置成功' })
        }
        this.queryInfo()
      })
      this.queryInfo()
      return true
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     // for (let i = 0; i < this.setForm.ips.length; i++) {
      //     // if (!this.setForm.ips[i].ip) {
      //     //   this.$message(`请输入第${i + 1}个IP`)
      //     //   return false
      //     // }
      //     if (ip && !/^(?:(?:1[0-9][0-9]\.)|(?:2[0-4][0-9]\.)|(?:25[0-5]\.)|(?:[1-9][0-9]\.)|(?:[0-9]\.)){3}(?:(?:1[0-9][0-9])|(?:2[0-4][0-9])|(?:25[0-5])|(?:[1-9][0-9])|(?:[0-9]))$/.test(ip)) {
      //       this.$message(`IP格式错误`)
      //       this.queryInfo()
      //       return false
      //     }
      //     // }
      //     if (ip) {
      //       setConfig({
      //         callback_url: this.setForm.callback_url,
      //         ip: [...this.setForm.ips.map(d => d.ip)].filter(d => d).toString()
      //       }).then(res => {
      //         if (res.code === 200) {
      //           this.$message({ type: 'success', message: '设置成功' })
      //           this.setForm.ips[index].addip = false
      //         }
      //         this.queryInfo()
      //       })
      //     } else {
      //       this.$message(`请输入IP`)
      //       this.queryInfo()
      //       return false
      //     }
      //   } else {
      //     return false
      //   }
      // })
    },
    look() {
      this.$alert(`${this.setForm.appsecret}`, 'ComSecret', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    },
    cancel() {
      this.setForm = { ...this.storeData }
      this.isEdit = !this.isEdit
    },
    delIP(index, ip) {
      const ips1 = [...this.setForm.ips.map(d => d.ip)].filter(d => d).toString()
      if (ip === ips1) {
        this.$message(`请先添加其他IP`)
        return false
      }
      this.setForm.ips.splice(index, 1)
      const ips = [...this.setForm.ips.map(d => d.ip)].filter(d => d).toString()
      if (ips) {
        setConfig({
          callback_url: this.setForm.callback_url,
          ip: ips
        }).then(res => {
          if (res.code === 200) {
            this.$message({ type: 'success', message: '删除成功' })
          }
          this.queryInfo()
        })
        this.queryInfo()
      } else {
        this.$message(`请输入IP`)
        this.queryInfo()
        return false
      }
    },
    addIP() {
      this.setForm.ips = [...this.setForm.ips, { ip: '', addip: true }]
    },
    copy() {
      const input = document.getElementById('appid')
      input.select()
      document.execCommand('Copy')
    }
  }
}
</script>

<style lang="scss" scoped>
.set{
  width: 700px;
  margin: 0 auto;
  .delip{
    right: -40px;
  }
  .saveip{
    right: -75px;
  }
}
.log_wrap{
  .el-timeline-item__timestamp{
    color: #333;
  }
}
</style>
